<template>
  <div></div>
</template>
<script>
export default {
  name: 'LoadingUpodeta',
  data() {
    return {
      progressMax: 0,
      okLoad: false
    }
  },
  methods: {
    minxLodadShow() {
      let VM = this
      this.$q.loading.show({
        message: VM.progressMax
      })
      let intervalId = setInterval(() => {
        VM.progressMax += 1
        this.$q.loading.show({
          message: '上传中' + VM.progressMax + '%'
        })
        if (VM.progressMax > 79 || this.okLoad) {
          clearInterval(intervalId)
        }
      }, 100)
    },
    minxLodadHide() {
      return new Promise((resolve) => {
        let VM = this
        let intervalId = setInterval(() => {
          VM.progressMax += 1
          this.$q.loading.show({
            message: '上传中' + VM.progressMax + '%'
          })
          if (VM.progressMax > 99) {
            clearInterval(intervalId)
            this.$q.loading.hide()
            VM.progressMax = 0
            resolve()
          }
        }, 10)
      })
    }
  }
}
</script>
